export default __webpack_public_path__ + "static/media/resume.0f47bed9.pdf";